import { LOCAL_CURRENCIES } from 'ui'
import store from '../../core/store'
import { setCheckoutFinishedSuccess } from '../../reducers/orderSlice'

const Natura = function (paymentGateway) {
  this.paymentGateway = paymentGateway
  this.quote = null
  this.checkout = null
  this.orderId = null
  this.products = []

  this.createQuote = ({ order }) => {
    this.quote = order
  }

  this.startCheckout = async () => null

  this.goToCheckout = ({ checkoutWindow }) => {
    const currentParams = new URLSearchParams(window.location.search)
    const consultoria = currentParams.get('consultoria')

    const basketItems = this.quote.orderDetails.map((orderDetail) => ({
      productId: orderDetail.product.sku,
      quantity: orderDetail.product.quantity,
    }))

    const basketJSON = JSON.stringify(basketItems)
    let baseUrl = null

    switch (this.paymentGateway.currencyId) {
      case LOCAL_CURRENCIES.AR:
        baseUrl = '/mi-carrito'
        break
      case 'MXN': //MXN is hardcoded due to LOCAL_CURRENCIES.MX refers to ARS (this was made because of an UI limitation regarding MXN)
        baseUrl = '/cart'
        break
      case LOCAL_CURRENCIES.PE:
        baseUrl = '/mi-carro'
        break
      case LOCAL_CURRENCIES.BR:
        baseUrl = '/sacola'
        break
      case LOCAL_CURRENCIES.CO:
        baseUrl = '/mi-carro'
        break
      default:
        break
    }

    const checkoutUrl = new URL(baseUrl, this.paymentGateway.urlCheckout)
    checkoutUrl.searchParams.set('sharebasket', basketJSON)
    if (consultoria) {
      checkoutUrl.searchParams.set('consultoria', consultoria)
    }

    const params = new URLSearchParams(checkoutUrl.search)

    params.set('utm_source', 'gojiraf')
    params.set('utm_medium', 'participant')
    params.set('utm_campaign', 'socios')

    checkoutUrl.search = params.toString()

    checkoutWindow.location.href = checkoutUrl.toString()
    checkoutWindow.focus()
    store.dispatch(setCheckoutFinishedSuccess(true))
  }
}

export default Natura
